export default {
  '短信设置': 'SMS Manage',
  '短信模版': '',
  '返回': 'Back',
  '查看流水': '',
  '短信供应商平台': 'SMS Provider Platform',
  '供应商': 'Supplier',
  '账号': 'Account',
  '密码': 'Password',
  '取消': 'Cancel',
  '确定': 'Confirm',
  '编辑模板': 'Editing Template',
  '保存': 'Save',
  '短信模板预览': 'SMS Template Preview',
  '短信模板编辑区': 'Editing Area',
  '不同短信供应商对短信字数限制不一，可能存在字数溢出的情况，请酌情规划模板字数': 'Different SMS platform limit on the number of words differ, there may be instances of words overflow, as appropriate, please plan template word.',
  '基本信息取值区': 'Basic Information Value Area',
  '点击将标签插入模板，短信会根据标签写入实际数值': 'Click to insert the label into the template, the SMS will write the actual value according to the label.',
  '验证码': 'Verify Code',
  '提示': 'Hint',
  '若模板没有保存，直接返回会丢失已修改的模板哦。确定吗？': 'If the template is not saved, returning directly will lose the modified template. Sure?',
  '功能类型': 'Function Type',
  '短信类型': 'SMS Type',
  '短信属性': 'SMS Template',
  '操作': 'Operation',
  '全局': 'Overall',
  '渠道': 'Channel',
  '开卡': 'Create New VIP',
  '储值卡': 'VIP Value',
  '消费': 'Consumption',
  '其他': 'Other',
  '开卡手机验证码': 'VIP Created Mobile Verification',
  '开卡成功提醒': 'VIP Created Success Reminder',
  '会员储值卡使用验证码': 'VIP Cards Use A Verification Code',
  '会员储值卡充值成功提醒': 'VIP Top-up Successful Reminder',
  '会员储值卡消费成功提醒': 'VIP Top-up Used Successful Reminder',
  '会员积分使用验证码': 'VIP Points Use A Verification Code',
  '会员积分充值成功提醒': 'VIP Points Successful Reminder',
  '会员积分消费成功提醒': 'VIP Points Used Successful Reminder',
  '特殊会员VIP折扣使用': 'Premium VIP Verification',
  '高级折扣权限短信验证码': 'Senior DCT Limited SMS Verification Code',
  '消费成功提醒': 'Consumption Success Reminder',
  '定金单下单成功提醒': 'Deposit  Recipet Success Reminder',
  '修改会员手机号成功提醒': 'Modify VIP Mobile Successful Reminder',
  '会员等级变动提醒': 'VIP Level Change Reminder',
  '停用': 'Stop',
  '启用': 'Enabled',
  '未开通短信服务': 'Not opened SMS notification service',
  '请联系信息部门': ' pls contact IT Dept',
  '店铺': 'Channel ',
  '搜索': 'Search',
  '店铺编号': 'Channel Code',
  '店铺名称': 'Channel Name',
  '知道了': 'I get it',
  '快捷设置': 'Quick Setup',
  '刷新促销': 'Update Promotion',
  'Web端使用ERP物流模块': 'WebPOS Using ERP Logistics Module',
  '渠道(批量)选择': '',
  '查询': 'Search',
  '渠道编号': 'Channel No.',
  '请输入渠道编号': 'Enter Channel No.',
  '渠道简称': 'Channel Name',
  '请输入渠道简称': 'Enter Channel Abbr Name',
  '经营模式': 'Business Module',
  '经营方式': 'Business Methods',
  '输入或选择': 'Enter/Choose',
  '公司': 'Company',
  '组': 'Group',
  '国家': 'Country',
  '销售类别': 'Sales Type',
  '渠道配置（已选择': 'Channel configuration (selected',
  '复制渠道配置（已选择': 'Copy Channel configuration (selected',
  '个渠道': 'channel',
  '单据打印样式': 'Document Print Style',
  '单据': 'Invoice',
  '销售单': 'Sales-Order',
  '定金单': 'Deposit Receipt',
  '会员充值单': 'Top-Up Receipt',
  '日结': 'Day-End',
  '交接班': 'Shift-turning',
  '本机日收银': 'Day\'s Cashier of Machine',
  '发货单': 'Delivery Invoice',
  '单据打印张数': 'Document Print No.',
  '短信模板': 'SMS Template',
  '选择短信模板': '',
  '模版方案': 'Template Scheme',
  '模版内容': 'Template Content',
  '阿里云短信签名': 'Ali Cloud SMS Signature',
  '选择短信签名': '',
  '保存成功': 'Saved',
  '打印张数': 'Document Print No.',
  '输入张数': 'Enter No.',
  '做单打印': 'Sales Print',
  '店铺联': 'Store Version',
  '客户联': 'Custome Version',
  '张数': 'Number',
  '不能全部为零': 'Not All Zero',
  '请填写完整的张数': 'Enter Fill No. of  Pages',
  '选择样式': 'Select Style',
  '简易版': 'Light Version',
  '简易版支持全部终端': 'Simple Version Supports All Machine Type',
  '类型': 'Type',
  '自定义版': 'Custom Version',
  '样式名称': 'Template Name',
  '预览': 'Preview',
  '自定义版仅支持Webpos优先使用': 'Custom Version Only Spports WEBPOS to USE',
  '变更记录': 'Change Log',
  '销售单小票': 'Sales',
  '定金单小票': 'Deposit',
  '充值单': 'Top-up Receipt  ',
  '请先选择模版': 'Select Template First',
  '再保存': 'Then save',
  '充值单据': 'Top-up Receipt',
  '500条/页': '500Page/Tage',
  '第': 'Page',
  '页': '',
  '序': 'Order',
  '共': 'Toal',
  '配置': 'Manage',
  '没有可选的数据': '',
  '渠道配置中心': 'Configuration Center',
  '支持配置小票样式&打印张数、短信模板': 'Support to configure receipt style & number of prints, SMS template',
  '已选择': 'Has chosen ',
  '状态': 'status',
  '配置说明': 'Configuration Instructions',
  '配置后，POS需重新登录后生效': 'Once Configured, POS must Re-Login',
  '渠道(批量)': 'Channel(Batch)',
  '请输入内容': 'Enter Content',
  '选项': 'Option',
  '清空': 'Clear',
  '列表': 'List',
  '编辑': 'Edit',
  '户口': 'Account',
  '批量配置单据打印样式': 'Set Print Style',
  '批量配置单据打印张数': 'Set Print No.',
  '批量配置短信模板': 'Set SMS Template',
  '复制其他渠道模板': 'Copy values to other channel templates',
  '会员充值小票': 'Top-Up Receipt',
  '日结小票': 'Day-End',
  '交接班小票': 'Shift Change',
  '本机日收银小票': 'Day\'s Cashier of Machine',
  '发货单小票': 'Shipping',
  '做单打印张数 店铺联/客户联': 'Document Print No. Store Version/Custome Version',
  '重打印张数 店铺联/客户联': 'Reprint No. Store Version/Custome Version',
  '未选择业务属性': 'No Business Type Selected',
  '请选择渠道': 'Select Channel',
  '同步ERP渠道资料成功！': 'ERP Channel Data Synchronization Success!',
  '系统默认模版': 'System Default Template',
  '做单': 'Sale',
  '企事业单位的全称或简称': 'Enterprises and Institutions Full or Abbreviated',
  '工信部备案网站的全称或简称': 'Full or Abbreviated Website of the Ministry of Industry for the Record',
  'APP应用的全称或简称': 'Full or Abbreviated Name of APP',
  '公众号或小程序的全称或简称': 'Full or Abbreviated Name of Wechat Public Account and Mini Program',
  '电商平台店铺名的全称或简称': 'Full or Abbreviated Name of E-commerce Platform Stores',
  '商标名的全称或简称': 'Full or Abbreviated Name of Trademark',
  '请输入签名来源': 'Enter Signature Source',
  '请输入签名说明': 'Enter Signature Description',
  '重新上传成功': 'Re-upload succeeded',
  '添加成功': 'Added',
  '上传图片不能大于2M': 'Picture Size is Less than 2M',
  '短信模板数量不能超过10个': 'SMS Termplast cannot Exceed 10',
  '请输入名称': 'Enter Name',
  '保存后': '',
  '模版将提交审核，': ' will be submitted for review after saving，',
  '审核通过前短信模版无法使用，确认吗？': 'It is unavailable before passing the audit. Confirm？',
  '已经存在该字段，不可重复添加': 'This Field Already Exists, Add Unrepeatable',
  '请选择要编辑的模版': 'Please Select a Template to Edit',
  '保存置灰且点击提示“审核中”“审核通过”模板不可修改': '',
  '删除成功': 'Deleted',
  '超过最大字数': 'Exceed the Maximum Number of Words',
  '模版中含有非法取值字段，请先删除再保存': 'Template contains an illegal value field, delete and then save',
  '短信模板不能为空！': 'SMS Template cannot be Empty',
  '短信模板缺少验证码！': 'SMS Template Missing Verification Code!',
  '短信模板保存成功': 'SMS Tmplate Saved Successfully',
  '重命名成功': 'Scheme Re-name Successed',
  '同步阿里云签名': 'Synchronization Signature of Ali Cloud',
  '输入在阿里云后台注册的签名名称，同步至企业管理后台': 'Enter the signature name in the register of Ali cloud background, synchronized to business management background',
  '签名名称不能为空': 'Signature Name Cannot be Empty',
  '同步签名成功': 'Synchronization Signature Successfully',
  '更新默认签名成功': 'Update Default Signature Succeeded',
  '删除签名成功': 'Deleted Signature Successfully',
  '请勿轻易切换供应商，审核状态将会被重置！': 'Do not switch suppliers easily, the audit status will be reset!',
  '添加账号': 'ADD ACCOUNT',
  '审核状态': 'Exam-status',
  '默认': 'Default',
  '重命名': 'Rename',
  '删除': 'Del.',
  '添加国际模板': 'International Template',
  '添加中文模板': 'Chinese Template',
  '国际': 'International',
  '中文': 'Chinese',
  '审核通过': 'Exam-Passed',
  '未审核': 'Un-Examined',
  '审核中': 'Examing',
  '审核失败': 'Examined Failed',
  '短信供应商设置': 'SMS Provider Platform',
  '短信签名': 'SMS Signature',
  '模板内容': 'Template Content',
  '模板方案': 'Template Scheme',
  '申请说明': 'Application Des',
  '签名名称': 'Signature Name',
  '同步阿里云短信签名': 'Sync Aliyun SMS signature',
  '默认签名': 'Default Signature ',
  '审核备注': 'Examine Note',
  '签名来源': 'Signature Source',
  '添加短信签名': 'Add SMS Signature',
  '同步ERP渠道资料': 'Upgrating ERP Channel Info',
  '重新上传': 'Re-upload',
  '确认删除该短信模板吗？': 'Are you sure to delete the SMS template?',
  '未配置模板的渠道将按默认模板发送短信': 'Channels without a configured template will send SMS according to the default template',
  '确认切换默认模板吗？': 'Confirm Switch the Default Template?',
  '添加模板': 'Add the template',
  '确认删除该短信签名吗？': 'Confirm to delete this message signature?',
  '请在申请说明中 详细描述您的业务使⽤场景，申请⼯信部备案⽹站的全称或简称请在此处填写域名，长度不超过200个字符': 'Please describe your business use scenario in detail in the application description, apply for the full name or abbreviation of the website registered by the Ministry of Information, please fill in the domain name here, no more than 200 characters',
  '请输入签名名称': 'Enter Signature Name',
  '当前⽀持jpg、png、gif或 jpeg格式的图⽚。': 'Currently supports images in jpg, png, gif or jpeg format.',
  '签名的证明⽂件格式，⽀持上传多张图⽚。': 'The signed certificate file format supports uploading multiple pictures.',
  '图片不超过2M': 'The picture is no more than 2M',
  '提交审核': 'Submit & Examined',
  '证明文件': 'Supporting documents',
  '短信签名未设置': 'SMS Signature Not Manage',
  '短信将无法发送': 'SMS Cannot Send',
  '区域': 'Area',
  '省份': 'Provinces',
  '渠道性质': 'Channel Type',
  '店铺联/顾客联打印张数不能全部为0': '店铺联/顾客联打印张数不能全部为0',
  '销售退款（储值积分返还）提醒': 'Sales Refund (Return of Stored Value & Points) Reminder',
  '渠道调出': 'Channel Call-out',
  '渠道退货': 'Channel Returns',
  '采购退货': 'Purchase Return',
  '退货通知': 'Returns Notice',
  '线上订单发货': 'Online Order Delivery',
  '渠道调入': 'Channel Call-in',
  '渠道收货': 'Channel-in',
  '退货': 'Return',
  '紧急发货': '',
  '发货': '',
  '配单': '',
  '全部': 'All',
  '重打印': 'Reprint',
  '积分': 'Points',
  '是否保存模板？': '',
  '配置教学': 'Configure Teaching',
  '已配置短信渠道': 'SMS Channel Configured',
  '已开启ERP权限': 'Turned ERP Eights',
  '未开启ERP权限': 'ERP is not Turned on Rights',
  '配置了该短信模板且已开通ERP权限的渠道，可正常使用短信功能': 'Configuring the SMS templates and permission has opened ERP Channel, can use SMS function normally',
  '配置了该模板但未开通ERP权限的渠道,请前往ERP渠道资料开通权限': 'The template is configured channels but did not open ERP rights Please go to the opening of ERP channel permissions',
  '短信配置主要为以下流程': 'SMS Configuration is Mainly the Following Process',
  '设置好短信签名，提交供应商审核（部分供应商无需配置签名）': 'Set up SMS signature, submit Supplier Audit (some vendors do not need to configure signature)',
  '点击短信类型右侧的编辑模板，保存后提交供应商审核': 'Click On the Right Type of SMS Template Editing, Save Submission Supplier Audit',
  '到': 'Reach',
  '开通渠道': 'Open Channel',
  '给不同渠道配置对应模板': 'In channel configuration center, channel configuration corresponds to a different template',
  '前往ERP渠道资料，开启所有渠道的短信发送权限': 'Go ERP channel information, open the SMS permissions for all channels',
  '请先选择模版再保存': 'Select Template First',
  '全部数据导入成功': 'All data imported successfully',
  '零售方式': 'Retail Methods',
  '积分清零提醒': '',
  '生日代用券': '',
  '短信签名一般为品牌名称，顾客短信可见，必填': '',
  '请填写短信签名': '',
  '若清空供应商，可能会丢失原有短信供应商的模板审核状态，请谨慎操作': '',
  '查询结果': 'Search Result',
  '搜索渠道': 'Search Channel',
  '重置': 'Reset',
  '条': 'Article',
  '100条/页': '100/Line',
  '200条/页': '200/Line',
  '300条/页': '300/Line',
  '400条/页': '400/Line',
  '800条/页': '800/Line',
  '1000条/页': '1000/Line',
  '请输入账号': 'Pls Enter Account(Acc)',
  '输入账号': 'Enter Account(Acc)',
  '请输入密码': 'Pls Enter Code',
  '输入密码': 'Enter Password',
  '账号不能为空': 'Must have Acc',
  '同步ERP收银员': 'Upgrating ERP Salesman Info',
  '使用教程': 'help documents',
  '不记名储值卡余额变动提醒': 'Balance Change Of The Stored-Value Card Reminder',
  '不记名储值卡开卡成功提醒': 'Opening Stored-Value Card Successful Reminder',
  '打印单据张数': '',
  '打印快递单张数': '',
  '打印快递单': '',
  '打印单据': '',
  '不记名卡使用验证': '',
  '更新版本': 'Updated version',
  '更新版本成功': 'Version updated successfully',
  '大版本号': 'Large version number',
  '忘记密码发送随机密码提醒': 'Forgot password send a random password reminder',
  '修改密码成功提醒': 'The password is changed successfully',
  'VIP积分兑换货品短信验证': ''
}


// WEBPACK FOOTER //
// ./src/i18n/en/note.js